import qs from "qs";
import tbkApi from "../../services/tbkApi";
import { LOAD_FIELDS } from "./Editor.actions";
import { each } from "lodash";

/**
 * A dispatchable function that knows how to fetch resources from the server.  props is an object that can contain
 * pagination, sorting, filter and search members.
 *
 * @param {Object} props
 *
 * @returns {function(*)}
 */
export const fetchFields = () => {
    return (dispatch) => {
        tbkApi.getEditorFields().then((fields) => {
            dispatch({
                type: LOAD_FIELDS,
                fields,
            });
        });
    };
};

function encodeDotsInParams(rawQuery) {
    if (!rawQuery) return "";

    // Step A: decode percent-encodings so we operate on logical characters
    // but only decode percent-escapes that are safe for round-trip (we'll re-encode).
    const decoded = rawQuery.split("&").map((pair) => {
        const [k = "", v = ""] = pair.split("=");
        return {
            k: decodeURIComponent(k),
            v: decodeURIComponent(v),
        };
    });

    // Step B: replace '.' with the literal sequence "%2E" in keys and values
    const withEscapedDots = decoded.map(({ k, v }) => {
        return {
            k: k.replace(/\./g, "%2E"),
            v: v.replace(/\./g, "%2E"),
        };
    });

    // Step C: encode each key/value once for placement in a path, but avoid re-encoding our "%2E"
    // We temporarily replace '%' with a placeholder to protect our %2E sequences.
    const placeholder = withEscapedDots.map(({ k, v }) => {
        const pk = k.replace(/%/g, "__P__");
        const pv = v.replace(/%/g, "__P__");
        return {
            k: encodeURIComponent(pk).replace(/__P__/g, "%"),
            v: encodeURIComponent(pv).replace(/__P__/g, "%"),
        };
    });

    // Step D: join back into the full encoded query (without leading '?')
    return placeholder.map(({ k, v }) => `${k}=${v}`).join("&");
}

export const promoToUrlParms = (promo) => {
    return encodeDotsInParams(qs.stringify(promo));
};

export const urlParmsToPromo = (urlParms) => {
    return qs.parse(urlParms, { ignoreQueryPrefix: true });
};

export const applyFieldValues = (fields, values) => {
    let newFields = {};
    each(fields, (field, key) => {
        newFields[key] = {
            ...field,
            value:
                !values || typeof values[field.name] === "undefined"
                    ? null
                    : values[field.name],
        };
        if (field.sub_fields) {
            newFields[key].sub_fields = Object.values(
                applyFieldValues(
                    newFields[key].sub_fields,
                    newFields[key].value,
                ),
            );
        }
    });
    return newFields;
};
